var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-area"},[_c('el-cascader',{attrs:{"size":"small","value":_vm.location,"options":_vm.options,"placeholder":"请输入城市名称","filterable":""},on:{"change":_vm.bindChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }